import http from "./http";

//#region API endpoints
const bandhanRegistration = (data) => {
  return http.post("/create-bandhan", data);
}
const getActiveGotra = () => {
  return http.get("/get-active-gotra/1");
}
const getActiveKuldevi = () => {
  return http.get("/get-active-kuldevi/1");
}
const login = (data) => {
  return http.post("/login", data);
}

const config = {
  bandhanRegistration,
  getActiveGotra,
  getActiveKuldevi,
  
};

export default config;
//#endregion
